<template>
    <div class="pavilion">
        <pavilion-header>虚拟展馆</pavilion-header>
        <div class="list" ref="dl">
            <dl 
                class="lis"
                v-for="item in virtualPavilionList" :key="item.id"
            >
                <dt :style="{ height: h + 'px' }"><a class="dt" :href="item.href"><img :src="item.image" alt=""></a></dt>
                <dd><a :href="item.href">{{ item.title }}</a></dd>
            </dl>
            <div class="btn" @click="handleBtnClick" v-if="isVisible">
                <div class="arrow" ref="btn"></div>   
            </div>
        </div>
        <div class="bg"></div>
        <div class="qdl" v-if="1==2">
            <div class="top_logo">
                <a target="_blank" href="http://www.qdlmedia.cn/"><img src="../../assets/images/qdl_logo.png" alt=""></a>
            </div>
            <p class="p">
                济南泉动力文化传媒有限公司，成立于2005年，是一家专业从事战略品牌策划、多媒体展览展示、产品可视化包装、互动空间设计、数字新媒体创意的整合性数字传播机构。企业秉承“创意独特、形式新颖、效果为王、客户为本”的原则，已助力许多企业在品牌宣传和大型招投标中脱颖而出，实现品牌与业绩的爆破式增长 企业早期以三维动画表现起家，深谙品牌传播规律和视觉传达技巧。近年来，将强大的艺术创意实力与现代新型展示手段相结合，在数字展示领域进行服务拓展，深入探究虚拟互动、视觉艺术、数字体验、主题创意、空间设计的多维跨界整合与应用。 在品牌战略研究方面，泉动力依托清华大学、济南大学设计战略与原型创新研究所，凝聚了国内知名的市场调研、品牌策划、多媒体设计等领域的顶尖实战人才，对品牌宣传、视觉表现、新媒体应用进行全局性、系统性研究设计，为公司的各类业务提供了强大的智力保证和人力支撑 “打造中国最具专业实力的数字视觉展示服务商，创新视觉服务，为企业创造最大经济价值”是泉动力始终如一的战略目标。目前，公司已形成了“市场战略研究—整合品牌策划—数字新媒体设计应用”的展示业务布局，从策划创意、方案设计，到多媒体设计、设备安装调试，为客户量身打造属于自己的一站式数字可视化解决方案。
            </p>
        </div>
        <div class="video" v-if="1==2">
            <video ref="video" @pause="pauseVideo" src="http://ii.sinelinked.com/download/qdl.mp4" controls width="100%"></video>
            <div class="video_bg" v-if="onOff" @click="autoPlayClick"></div>
        </div>
        <div class="code" v-if="1==2">
            <img src="../../assets/images/code.jpg" alt="">
        </div>
    </div>
</template>

<script>
import pavilionHeader from '../../components/Header';
export default {
    name: 'pavilion',
    components: {
        pavilionHeader
    },
    data() {
        return {
            virtualPavilionList: [],
            h: '',
            page: 1,
            isVisible: true,
            onOff: true,
            h: ''
        }
    },
    mounted() {
        this.getVirtualPavilion(1,4)
        this.$nextTick(()=>{
            this.getLisWidth()
        })
        // this.getVideoHeight()
    },
    methods: {
        // 获取虚拟展馆列表
        getVirtualPavilion(pageNo,pageSize) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: '518159680f6740eaac4bff40d64ab9e6',
                    pageNo,
                    pageSize,
                    contentType: 'LINK'
                }
            }).then(res => {
                if(res.data.code == 0){
                    console.log(res);
                    let arr = res.data.page.list
                    this.virtualPavilionList = this.virtualPavilionList.concat(arr)
                    this.totalPage = res.data.page.totalPage
                    console.log(this.virtualPavilionList);
                }
            }).catch(err => {
                console.log(err.response.data.error);
            })
        },
        // 获取li的宽度
        getLisWidth() {
            this.h = this.$refs.dl.clientWidth * 0.48
        },
        handleBtnClick() {
            this.page ++
            this.getVirtualPavilion(this.page,4)
            if(this.totalPage == this.page){
                this.isVisible = false
                return
            }
        },
        autoPlayClick(){
            this.onOff = !this.onOff
            console.log(this.$refs.video);
            this.$refs.video.play()
        },
        pauseVideo() {
            this.onOff = !this.onOff
        },
    },
}
</script>

<style scoped>
    
    .list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 0 .3rem;
        background: #fff;
        padding-bottom: .6rem;
    }
    .list .lis {
        text-align: center;
        font-size: .24rem;
        width: 48%;
        margin-top: .3rem;
    }
    .list .lis dt .dt{
        width: 100%;
        height: 100%;
        display: block;
        background: #F2F3F7;
    }
    .list .lis dt img{
        width: 100%;
        height: 100%;
    }
    .list .lis dd{
        margin-top: .1rem;
    }
    .list .lis dd a{
        color: #333;
        line-height: 1.5;
    }
    .list .btn{
        width: 2rem;
        height: .5rem;
        border-radius: .06rem;
        background: #0076C0;
        margin: .3rem auto 0;
        text-align: center;
    }
    .list .btn .arrow{
        width: .3rem;
        height: .3rem;
        border: .02rem solid #fff;
        border-top: none;
        border-left: none;
        display: inline-block;
        transform: rotate(45deg);
    }
    .bg{
        height: .2rem;
        background: #F2F3F7;
    }
    .qdl{
        padding: .26rem .3rem;
        margin-top: .2rem;
        background: #fff;
    }
    .qdl .top_logo{
        text-align: center;
    }
    .qdl .top_logo img{
        width: 3rem;
    }
    .qdl .p{
        text-indent: 2em;
        font-size: .28rem;
        line-height: 1.5;
        margin: .26rem 0;
    }
    .video{
        position: relative;
        margin: 0 .3rem .3rem;
    }
    .video .video_bg{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: url('../../assets/images/video_bg.jpg') no-repeat;
        background-size: 100%; 
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .code{
        margin: 0 .3rem .3rem;
    }
    .code img{
        width: 100%;
    }
</style>